import { makeRule } from '@core/utils/rule.js'

export const userRoleFormRules = {
  admin_ids: [
    makeRule('请选择管理员', 'array')
  ],
  role_ids: [
    makeRule('请选择角色', 'array')
  ]
}



// WEBPACK FOOTER //
// ./src/views/platform-user/platform-user.rules.js